export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">热门推荐</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            基于海量漫迷阅读数据精选，每日更新最值得一看的热门漫画
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">

          <a href="#cards" className="group cursor-pointer">
            <div className="relative aspect-[3/4] rounded-xl overflow-hidden bg-background-200 mb-3">
              <img
                src="https://readdy.ai/api/search-image?query=Vertical%20manga%20cover%20style%20illustration%20of%20romance%20story%20with%20couple%20under%20starry%20night%20sky%2C%20soft%20pink%20and%20lavender%20color%20palette%2C%20dreamy%20atmosphere%2C%20simple%20elegant%20background%2C%20shoujo%20manga%20aesthetic%20cover%20art&width=600&height=800&seq=card-01&orientation=portrait"
                alt="星辰恋语"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
              />
              <div className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-primary-500 text-[10px] font-medium text-background-50">恋爱</div>
            </div>
            <h3 className="text-sm font-heading font-semibold text-foreground-950 text-center line-clamp-1 mb-1">星辰恋语</h3>
            <p className="text-xs text-foreground-500 text-center">樱庭花音</p>
            <p className="text-xs text-foreground-500 text-center">第48话</p>
            <p className="text-xs text-primary-600 text-center mt-0.5 font-medium">🔥 98.5万</p>
          </a>

          <a href="#cards" className="group cursor-pointer">
            <div className="relative aspect-[3/4] rounded-xl overflow-hidden bg-background-200 mb-3">
              <img
                src="https://readdy.ai/api/search-image?query=Vertical%20manga%20cover%20style%20illustration%20of%20action%20fantasy%20warrior%20with%20sword%20against%20dramatic%20sunset%2C%20warm%20orange%20and%20gold%20tones%2C%20epic%20composition%2C%20shounen%20manga%20aesthetic%2C%20clean%20background%20cover%20art&width=600&height=800&seq=card-02&orientation=portrait"
                alt="剑域风云"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
              />
              <div className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-primary-500 text-[10px] font-medium text-background-50">热血</div>
            </div>
            <h3 className="text-sm font-heading font-semibold text-foreground-950 text-center line-clamp-1 mb-1">剑域风云</h3>
            <p className="text-xs text-foreground-500 text-center">寒武纪</p>
            <p className="text-xs text-foreground-500 text-center">第132话</p>
            <p className="text-xs text-primary-600 text-center mt-0.5 font-medium">🔥 86.2万</p>
          </a>

          <a href="#cards" className="group cursor-pointer">
            <div className="relative aspect-[3/4] rounded-xl overflow-hidden bg-background-200 mb-3">
              <img
                src="https://readdy.ai/api/search-image?query=Vertical%20manga%20cover%20style%20illustration%20of%20mystery%20thriller%20with%20dark%20silhouettes%20and%20dramatic%20shadows%2C%20deep%20amber%20and%20warm%20brown%20tones%2C%20film%20noir%20inspired%20composition%2C%20suspenseful%20cover%20art%20aesthetic&width=600&height=800&seq=card-03&orientation=portrait"
                alt="暗夜追逐"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
              />
              <div className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-primary-500 text-[10px] font-medium text-background-50">悬疑</div>
            </div>
            <h3 className="text-sm font-heading font-semibold text-foreground-950 text-center line-clamp-1 mb-1">暗夜追逐</h3>
            <p className="text-xs text-foreground-500 text-center">林深时</p>
            <p className="text-xs text-foreground-500 text-center">第67话</p>
            <p className="text-xs text-primary-600 text-center mt-0.5 font-medium">🔥 74.8万</p>
          </a>

          <a href="#cards" className="group cursor-pointer">
            <div className="relative aspect-[3/4] rounded-xl overflow-hidden bg-background-200 mb-3">
              <img
                src="https://readdy.ai/api/search-image?query=Vertical%20manga%20cover%20style%20illustration%20of%20historical%20fantasy%20with%20ancient%20Chinese%20palace%20and%20flowing%20hanfu%2C%20elegant%20ink%20wash%20painting%20meets%20modern%20manga%20style%2C%20warm%20earth%20tones%2C%20refined%20composition&width=600&height=800&seq=card-04&orientation=portrait"
                alt="千秋岁"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
              />
              <div className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-primary-500 text-[10px] font-medium text-background-50">古风</div>
              <div className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-accent-500 text-[10px] font-medium text-background-50">完结</div>
            </div>
            <h3 className="text-sm font-heading font-semibold text-foreground-950 text-center line-clamp-1 mb-1">千秋岁</h3>
            <p className="text-xs text-foreground-500 text-center">墨染青衣</p>
            <p className="text-xs text-foreground-500 text-center">全120话</p>
            <p className="text-xs text-primary-600 text-center mt-0.5 font-medium">🔥 112.3万</p>
          </a>

          <a href="#cards" className="group cursor-pointer">
            <div className="relative aspect-[3/4] rounded-xl overflow-hidden bg-background-200 mb-3">
              <img
                src="https://readdy.ai/api/search-image?query=Vertical%20manga%20cover%20style%20illustration%20of%20sweet%20romance%20with%20cheerful%20couple%20in%20cafe%20setting%2C%20warm%20pastel%20coral%20and%20peach%20color%20palette%2C%20bright%20energetic%20vibe%2C%20modern%20shoujo%20manga%20aesthetic%20cover%20art&width=600&height=800&seq=card-05&orientation=portrait"
                alt="蜜糖陷阱"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
              />
              <div className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-primary-500 text-[10px] font-medium text-background-50">恋爱</div>
              <div className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-accent-500 text-[10px] font-medium text-background-50">完结</div>
            </div>
            <h3 className="text-sm font-heading font-semibold text-foreground-950 text-center line-clamp-1 mb-1">蜜糖陷阱</h3>
            <p className="text-xs text-foreground-500 text-center">SweetPie</p>
            <p className="text-xs text-foreground-500 text-center">全86话</p>
            <p className="text-xs text-primary-600 text-center mt-0.5 font-medium">🔥 105.6万</p>
          </a>

          <a href="#cards" className="group cursor-pointer">
            <div className="relative aspect-[3/4] rounded-xl overflow-hidden bg-background-200 mb-3">
              <img
                src="https://readdy.ai/api/search-image?query=Vertical%20manga%20cover%20style%20illustration%20of%20supernatural%20fantasy%20with%20energy%20effects%20and%20glowing%20elements%2C%20warm%20coral%20and%20deep%20purple%20color%20palette%2C%20dynamic%20composition%2C%20shounen%20fantasy%20aesthetic%20cover%20art&width=600&height=800&seq=card-06&orientation=portrait"
                alt="异能觉醒"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
              />
              <div className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-primary-500 text-[10px] font-medium text-background-50">奇幻</div>
            </div>
            <h3 className="text-sm font-heading font-semibold text-foreground-950 text-center line-clamp-1 mb-1">异能觉醒</h3>
            <p className="text-xs text-foreground-500 text-center">极光工作室</p>
            <p className="text-xs text-foreground-500 text-center">第95话</p>
            <p className="text-xs text-primary-600 text-center mt-0.5 font-medium">🔥 67.9万</p>
          </a>

        </div>
      </div>
    </section>
  );
}